import type { PendingEntry } from '../worklog/models';
import type { DayCell, ExportRow } from './models';

type CallerStamp = {
    developer: string;
};

export const applyEntryToCell = (cell: DayCell, entry: PendingEntry, caller: CallerStamp): DayCell => {
    if (entry.action === 'remove') {
        const removeIdx = cell.savedEntries.findIndex((row) => row.issueId === entry.workItemId && row.hours === entry.hours);
        if (removeIdx < 0) {
            return cell;
        }
        const nextEntries = cell.savedEntries.filter((_, i) => i !== removeIdx);
        return {
            ...cell,
            savedEntries: nextEntries,
            savedHours: Math.max(0, cell.savedHours - entry.hours),
        };
    }

    const newRow: ExportRow = {
        rowDate: entry.date,
        hours: entry.hours,
        developer: caller.developer,
        department: '',
        issueId: entry.workItemId,
        issueTitle: entry.workItemTitle,
        workItemType: entry.workItemType,
        workTypeLabel: null,
    };
    return {
        ...cell,
        savedEntries: [...cell.savedEntries, newRow],
        savedHours: cell.savedHours + entry.hours,
    };
};

export type { CallerStamp };
